import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Date",
  "Lead Name",
  "From",
  "To",
  "Reson",
  "Generated By",
  "Actions",
];

const GetTransferTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-transfer/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.lead?.full_name || "N/A"}</td>
                <td>{item?.fromOwenerName || "N/A"}</td>
                <td>{item?.toOwnerName || "N/A"}</td>
                <td>{item?.reason || "N/A"}</td>
                <td>{item?.generatedBy || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GetTransferTable;
